// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
// AudioLibraryService provides endpoints for managig audio files. This is rebrand from Media and MediaFile.
// NWX Endpoints. Location-id is not used.
export const AudioLibraryService = {
    // List audio files by tenant
    List(fn, req) {
        return fn(`/phone/audio-library/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Delete the audio library.
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["mediaItemId"], "mediaItemId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/audio-library/v1/${req["mediaItemId"]}?${fm.renderURLSearchParams(req, ["mediaItemId"])}`, { method: "DELETE" });
    },
    // Rename the audio file.
    Rename(fn, req) {
        try {
            fm.validateUrlParam(req["mediaItemId"], "mediaItemId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/audio-library/v1/${req["mediaItemId"]}/rename`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // Usage shows where the audio library is being used.
    Usage(fn, req) {
        try {
            fm.validateUrlParam(req["mediaItemId"], "mediaItemId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/audio-library/v1/${req["mediaItemId"]}/usage?${fm.renderURLSearchParams(req, ["mediaItemId"])}`, { method: "GET" });
    },
};
